/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Office_Logo_SettingsInputs */

const cs_draft_office_logo_settings = /** @type {(inputs: Draft_Office_Logo_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavení kanceláře`)
};

const en_draft_office_logo_settings = /** @type {(inputs: Draft_Office_Logo_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office settings`)
};

/**
* | output |
* | --- |
* | "Office settings" |
*
* @param {Draft_Office_Logo_SettingsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_office_logo_settings = /** @type {((inputs?: Draft_Office_Logo_SettingsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Office_Logo_SettingsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_office_logo_settings(inputs)
	return cs_draft_office_logo_settings(inputs)
});